export default __webpack_public_path__ + "static/media/by-train.25514efa.svg";